import {
  ApiGetHook,
  ApiMutateHook,
  useApiGet,
  useApiMutate,
} from "@skanska/vsa-client-auth";
import { ApiMethods } from "../models/ApiMethods";
import { ApiEndpoints } from "../models/ApiEndpoints";
import {
  AddEntraGroupMemberRequest,
  EntraGroupKey,
  EntraGroupMember,
  EntraUser,
  RemoveEntraGroupMemberRequest,
} from "../models/EntraGroupMembership";

export function useSearchEntraUsers(query: string): ApiGetHook<EntraUser[]> {
  const normalizedQuery = query.trim();
  const endpoint = `${ApiEndpoints.EntraGroupMembershipUsers}?query=${encodeURIComponent(normalizedQuery)}`;

  return useApiGet<EntraUser[]>(
    endpoint,
    null,
    ["entra-group-users", normalizedQuery],
    { enabled: normalizedQuery.length >= 2 }
  );
}

export function useAddEntraGroupMember(): ApiMutateHook<
  EntraGroupMember,
  AddEntraGroupMemberRequest
> {
  return useApiMutate<EntraGroupMember, AddEntraGroupMemberRequest>(
    ApiEndpoints.EntraGroupMembershipMembers,
    ApiMethods.Post,
    null,
    null
  );
}

export function useEntraGroupMembers(
  groupKey: EntraGroupKey | null
): ApiGetHook<EntraGroupMember[]> {
  return useApiGet<EntraGroupMember[]>(
    groupKey === null
      ? ApiEndpoints.EntraGroupMembershipMembers
      : `${ApiEndpoints.EntraGroupMembershipMembers}/${groupKey}`,
    null,
    ["entra-group-members", groupKey ?? "none"],
    { enabled: groupKey !== null }
  );
}

export function useRemoveEntraGroupMember(): ApiMutateHook<
  void,
  RemoveEntraGroupMemberRequest
> {
  return useApiMutate<void, RemoveEntraGroupMemberRequest>(
    ApiEndpoints.EntraGroupMembershipMembers,
    ApiMethods.Delete,
    null,
    null
  );
}
